import imagen from "../img/image1.jpeg";
import ReplyIcon from '@mui/icons-material/Reply';
import HomeIcon from "@mui/icons-material/Home";

const mobilePersonalPhoto = (setActiveStep) => {
  return (
    <div className="w-full bg-gris text-center content-center shadow-lg p-3 h-[20vh]">
      <div className="grid grid-cols-[40%_50%]">
        <div>
          <div
            onClick={() => setActiveStep(0)}
            className="w-7 h-7 bg-negro rounded-full flex items-center justify-center absolute ml-[80px] mt-[-5px] z-[9999] 
             active:bg-main active:scale-90 transition duration-150 ease-in-out cursor-pointer"
          >
            <HomeIcon className="text-amarillo" style={{ fontSize: 21 }} />
          </div>

          <img
            src={imagen}
            alt="profile"
            className="rounded-full object-cover mx-auto mt-1 w-[80px] h-[80px]"
            style={{zIndex: 100}}
          />
        </div>
        <div>
          <p className="text-base text-white font-bold mt-0">Jesús Gómez Urbano</p>
          <p className="text-[13px] text-main">Maestro en Sistemas computacionales</p>
          <p className="text-[13px] text-main">Full stack developer</p>
        </div>
      </div>
  </div>
  )
}

const desktopPhoto = () => 
{
  return (
    <div className="w-full bg-gris text-center content-center shadow-lg p-3 h-auto">
    <img
      src={imagen}
      alt="profile"
      className="rounded-full object-cover mx-auto w-[100px] h-[100px]"
    />
    <p className="text-base text-white font-bold mt-2">Jesús Gómez Urbano</p>
    <p className="text-[13px] text-main">Maestro en Sistemas computacionales</p>
    <p className="text-[13px] text-main">Full stack developer</p>
  </div>
  )
}

const PersonalPhoto = ({isMobile = false, setActiveStep}) => (
  isMobile ? mobilePersonalPhoto(setActiveStep) : desktopPhoto()
);

export default PersonalPhoto;